Ext.define('SA.ChartLegendEditLabelledItem', {
    alias: 'widget.chart-legend-edit-labelled-item',
    extend: 'SA.view.SimpleContainer',

    baseCls: 'sa-chart-legend-edit-labelled-item',

    initComponent() {
        this.items = [
            {
                xtype: 'component',
                cls: 'sa-chart-legend-edit-labelled-item-label',
                html: this.label
            },
            this.item
        ];

        this.callParent();
    }
});